import resolvePromise from '../helper/resolved_promise';
import { NotifyMeActions } from '../constants/notify_me/notify_me_actions';
import Dispatcher from '../dispatcher';

function showAction() {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SHOW_ACTION
    });

    return resolvePromise();
}

function hideAction() {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.HIDE_ACTION
    });

    return resolvePromise();
}

function formSubmitAction(payload) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.FORM_SUBMIT,
        payload,
    });

    return resolvePromise();
}

function setQuantityAction(quantity) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_QUANTITY_ACTION,
        payload: parseInt(quantity, 10)
    });

    return resolvePromise();
}

function setNameAction(name) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_NAME_ACTION,
        payload: name
    });

    return resolvePromise();
}

function setMarketingConsentAction(payload) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_MARKETING_CONSENT_ACTION,
        payload,
    });

    return resolvePromise();
}

function setEmailAction(email) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_EMAIL_ACTION,
        payload: email
    });

    return resolvePromise();
}

function setPhoneAction(phone) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_PHONE_ACTION,
        payload: phone
    });

    return resolvePromise();
}

function setSkuAction(sku) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_SKU_ACTION,
        payload: sku
    });

    return resolvePromise();
}

function emailInvalidAction() {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.EMAIL_INVALID_ACTION
    });

    return resolvePromise();
}

function emailValidAction() {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.EMAIL_VALID_ACTION
    });

    return resolvePromise();
}

function phoneInvalidAction() {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.PHONE_INVALID_ACTION
    });

    return resolvePromise();
}

function phoneValidAction() {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.PHONE_VALID_ACTION
    });

    return resolvePromise();
}

function setTypeAction(payload) {
    Dispatcher.handleNotifyMeAction({
        type: NotifyMeActions.SET_TYPE_ACTION,
        payload
    });

    return resolvePromise();
}

export {
    showAction,
    hideAction,
    setQuantityAction,
    setNameAction,
    setMarketingConsentAction,
    setEmailAction,
    setPhoneAction,
    setSkuAction,
    emailInvalidAction,
    emailValidAction,
    phoneInvalidAction,
    phoneValidAction,
    setTypeAction,
    formSubmitAction
};